module.exports = __webpack_public_path__ + "static/media/2013_mar_mort.c186ff2a.jpg";